import React, { createContext, FC, PropsWithChildren, useEffect, useState } from "react";
import CartOrder from "../@types/CartOrder";
import Cart from "../@types/Cart";

interface CartOrderContxt {
    initialOrder: Partial<CartOrder> | undefined,
    setInitialOrder: React.Dispatch<React.SetStateAction<Partial<CartOrder> | undefined>>,
    tab: string,
    setTab: React.Dispatch<React.SetStateAction<string>>,
    loading: boolean,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    showCartConfigModal: boolean,
    setShowCartConfigModal: React.Dispatch<React.SetStateAction<boolean>>,
    orderMinimumCartQuantity: number,
    orderMaximumCartQuantity: number,
    cartToEdit: Cart | undefined,
    cartToEditIndex: number,
    setCartToEdit: React.Dispatch<React.SetStateAction<Cart | undefined>>,
    setCartToEditIndex: React.Dispatch<React.SetStateAction<number>>,
}

const CartOrderContext = createContext<CartOrderContxt | undefined>(undefined);

export const CartOrderProvider: FC<PropsWithChildren> = ({ children }) => {
    const orderMinimumCartQuantity: number = 1;
    const orderMaximumCartQuantity: number = 99999;
    const [initialOrder, setInitialOrder] = useState<Partial<CartOrder> | undefined>(undefined);
    const [tab, setTab] = useState<string>('order');
    const [showCartConfigModal, setShowCartConfigModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [cartToEdit, setCartToEdit] = useState<Cart | undefined>();
    const [cartToEditIndex, setCartToEditIndex] = useState<number>(-1);

    /*
        Function for handling retrieving order data from local storage
    */
    const retrieveFromLocalStorage = (key: string) => {
        const localData = localStorage.getItem(key);
        const localDataParsed = localData ? JSON.parse(localData) : undefined;

        // TODO remove cart inventory order check once
        // we resume custom orders
        const isInventoryOrder = localDataParsed?.fromInventoryOnly;
        return !isInventoryOrder ? localDataParsed : undefined;
    }

    /*
        When initializing CartOrderContext retrieve existing order from local storage
        when an order exists
    */
    useEffect(() => {
        const existingOrder = retrieveFromLocalStorage('cart-order-persist');
        if (existingOrder)
            setInitialOrder(existingOrder);
    }, []);

    return (
        <CartOrderContext.Provider
            value={{
                initialOrder,
                setInitialOrder,
                tab,
                setTab,
                loading,
                setLoading,
                showCartConfigModal,
                setShowCartConfigModal,
                orderMaximumCartQuantity,
                orderMinimumCartQuantity,
                cartToEdit,
                cartToEditIndex,
                setCartToEdit,
                setCartToEditIndex
            }}>
            {children}
        </CartOrderContext.Provider>
    )
}

export default CartOrderContext;